import i18n from 'i18next';
import en from '../locales/en';
import i18nFormat from '../lib/i18nFormat';
import {legacyIsProduction as isProduction} from './Environment';

const missingKeyHandler = (_lng: readonly string[], _ns: string, key: string) => {
  throw new Error(`Missing translation: ${key}`);
};

export const defaultNS = 'translation' as const;

export const resources = {
  en: {
    translation: en,
  },
} as const;

i18n.init({
  lng: 'en',
  fallbackLng: 'en',
  defaultNS: 'translation',
  resources: {
    en: {
      translation: en,
    },
  },
  missingKeyHandler,
  saveMissing: !isProduction,
  interpolation: {
    escapeValue: false,
    format: i18nFormat,
  },
  supportedLngs: ['en'],
});

export type I18n = typeof i18n;

export default i18n;
